import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 3,
  class: "qty-chip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.items,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        "row-selection": _ctx.rowSelection,
        scroll: { x: 1260 },
        class: "text-nowrap align-middle stock-report-table",
        onChange: _ctx.handleChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.no_stock_reports_found`)), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'type')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["type-badge", Number(record.type) === 1 ? 'type-standard' : 'type-service'])
              }, _toDisplayString(Number(record.type) === 1 ? _ctx.$t(`${_ctx.i18nScope}.type_standard`) : _ctx.$t(`${_ctx.i18nScope}.type_service`)), 3))
            : (column && column.key === 'cost')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.cost)), 1)
                ], 64))
              : (column && column.key === 'price')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.price)), 1)
                  ], 64))
                : (column && column.key === 'stock')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(Number(record.instock_qty ?? 0)) + _toDisplayString(record.unit ? ` ${record.unit}` : ""), 1))
                  : (column && column.key === 'status')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        class: _normalizeClass(["status-badge", _ctx.getStatusClass(record)])
                      }, _toDisplayString(_ctx.getStatusLabel(record)), 3))
                    : (column && column.key === 'total_cost')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createTextVNode(_toDisplayString(Number(record.type) === 1 ? `$${_ctx.formatAmount(Number(record.instock_qty ?? 0) * Number(record.cost ?? 0))}` : "-"), 1)
                        ], 64))
                      : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "row-selection", "onChange"])
    ])
  ]))
}